module.exports = "<div class=\"contact-customer-service bg-color hide\"> <%= consult_agent %> </div> ";